import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVouchersCorpStartkitParams, GetVouchersCorpStartkitResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const getVouchersCorpStartkit = createAsyncThunk<
  GetVouchersCorpStartkitResponse,
  GetVouchersCorpStartkitParams
>(
  `vouchers/getVouchersCorpStartkit`,
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getVouchersCorpStartkit({ voucherId, ...params });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting vouchers corp startkit",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting vouchers corp startkit", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
